import { render } from "./ServiceCard.vue?vue&type=template&id=590b18f6"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__